import { getCookie, isUserSignedIn } from 'utils/browserHelper'

export const eligibleUserEmail = [
    'vishwa@flyin.com',
    'jay.prakash@flyin.com',
    'govind.kumar@flyin.com',
    'kulasekar.reddy@flyin.com',
    'anirudh.damodar@flyin.com',
    'sandeep.nair@cleartrip.ae'
]
export const isTripAddEligibleInternalUser = () => {
    if (isUserSignedIn()) {
        const [email] = decodeURIComponent(getCookie('userid') || '').split('|')
        return eligibleUserEmail.includes(email.toLowerCase())
    }

    return false
}
